import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';


export default /*#__PURE__*/_defineComponent({
  __name: 'AccordionElement',
  props: {
    headers: {},
    contents: {}
  },
  setup(__props: any) {

const props = __props;




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Accordion), {
    "expand-icon": "icon icon-arrow-down-dark",
    "collapse-icon": "icon icon-arrow-up-dark"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.headers, (header, index) => {
        return (_openBlock(), _createBlock(_unref(AccordionTab), {
          key: index,
          header: header,
          pt: {
                header: {
                    'role': 'heading',
                    'aria-level': '3'
                }
            }
        }, {
          default: _withCtx(() => [
            _createCommentVNode(" eslint-disable vue/no-v-html "),
            _createElementVNode("div", {
              innerHTML: props.contents[index]
            }, null, 8 /* PROPS */, _hoisted_1)
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["header"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _: 1 /* STABLE */
  }))
}
}

})